import { useId as o } from "react";
const c = (s) => {
  switch (typeof s) {
    case "boolean":
    case "undefined":
      return [];
    case "string":
      return [s];
    default:
      return [...new Set(s)];
  }
}, u = (s) => {
  const t = o(), e = Array.isArray(s) ? s.length > 0 : !!s, n = c(s).map((r, a) => ({
    message: r,
    id: `${t}-${a}`
  }));
  return { isInvalid: e, errorMessages: n };
};
export {
  u as useInputErrorMessages
};
//# sourceMappingURL=useInputErrorMessages.js.map
